import React, { useEffect, useState } from "react";

import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";

import { NutrientsList } from "api/models";
import { resources } from "api/resources";
import { useQuery } from "api/useQuery";
import {
  BorderBox,
  Header2,
  Layout,
  PageLoadStateProvider
} from "components/common";
import { TranslationProvider } from "components/useTranslations";

import NutrientsAdditionButton from "./NutrientsAddButton";
import NutrientsTable from "./NutrientsTable";
import useNutrientsPageStyles from "./useNutrientsPageStyles";

const NutrientsPage: React.FC = () => {
  const [selectedVersion, setSelectedVersion] = useState<string | null>(null);

  const versionedResource = resources.nutrients(selectedVersion ?? undefined);

  const { data: response, isLoading: nutrientsLoading } =
    useQuery<NutrientsList>(versionedResource);

  const styles = useNutrientsPageStyles();

  useEffect(() => {
    if (response?.translations && !selectedVersion) {
      const defaultVersion =
        response.translations[
          // eslint-disable-next-line @typescript-eslint/dot-notation
          "__NUTRIENTS_INITIAL_VIEW_ALL_NUTRIENTS_CNS_VERSION"
        ];
      if (defaultVersion) setSelectedVersion(defaultVersion);
    }
  }, [response?.translations, selectedVersion]);

  return (
    <PageLoadStateProvider isLoaded={!!response?.translations}>
      <TranslationProvider translations={response?.translations}>
        {t => (
          <BorderBox width="full" height="full">
            <Layout layoutStyle="page">
              <Grid container>
                <Grid size={{ xs: 12 }}>
                  <div className={styles.headerStyling}>
                    <Header2>{t`__NUTRIENTS_INITIAL_VIEW_TITLE`}</Header2>
                    <NutrientsAdditionButton
                      translations={response?.translations}
                    />
                  </div>
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <FormControl
                    variant="outlined"
                    size="small"
                    style={{ minWidth: 200, marginBottom: 16 }}
                  >
                    <InputLabel id="cns-version-label">
                      {t`__NUTRIENTS_INITIAL_VIEW_CNS_VERSION_DROPDOWN_DEFAUL`}
                    </InputLabel>
                    <Select
                      label={t`__NUTRIENTS_INITIAL_VIEW_CNS_VERSION_DROPDOWN_DEFAUL`}
                      labelId="cns-version-label"
                      value={
                        selectedVersion ??
                        t`__NUTRIENTS_INITIAL_VIEW_ALL_NUTRIENTS_CNS_VERSION`
                      }
                      onChange={e => setSelectedVersion(e.target.value)}
                    >
                      {response?.cnsVersionOptions?.map(option => (
                        <MenuItem
                          key={option.keyValue}
                          value={option.displayValue}
                        >
                          {option.displayValue}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <NutrientsTable
                    nutrients={response?.nutrients ?? []}
                    nutrientsLoading={nutrientsLoading}
                    translations={response?.translations}
                  />
                </Grid>
              </Grid>
            </Layout>
          </BorderBox>
        )}
      </TranslationProvider>
    </PageLoadStateProvider>
  );
};

export default NutrientsPage;
